export default {
  data () {
    return {
      // 验证信息
      promptMessage: {},
      username: '', // 用户名
      companyName: '', // 公司名称
      phoneNumber: '', // 电话号码
      verifyCode: '', // 验证码
      intention: '' // 意向
    }
  },
  methods: {
    /**
     * 获取验证码
     */
    getVerify () {
      this.axios.get(`https://api.jarviscoder.com/super/common/verifycode?phone=${this.phoneNumber}`)
    },
    /**
     * 提交
     * @returns {Promise<void>}
     */
    async submitApply () {
      let result = await this.submitVerify()
      if (result) {
        try {
          this.axios.post('https://api.jarviscoder.com/super/customerintention/insert', {
            CompanyName: this.companyName,
            ContactName: `奥创工作手机官网,姓名:${this.username}`,
            Phone: this.phoneNumber,
            Intention: '试用',
            ProductType: '合作伙伴',
            extra: { 'remark': this.intention, 'companyName': this.companyName }
          })
        } catch (e) {}
        this.promptMessage = {
          success: '您已提交申请,请耐心等待反馈'
        }
        setTimeout(() => {
          window.close()
        }, 3000)
      }
    },
    /**
     * 提交前验证
     * @returns {Promise<*>}
     */
    async submitVerify () {
      if (!this.username.trim()) {
        this.promptMessage = {
          username: '请填写用户名'
        }
        return false
      }
      if (!this.companyName.trim()) {
        this.promptMessage = {
          companyName: '请填写公司名.'
        }
        return false
      }
      if (!this.phoneNumber.trim()) {
        this.promptMessage = {
          phoneNumber: '请填手机号.'
        }
        return false
      }
      if (!this.verifyCode.trim()) {
        this.promptMessage = {
          verifyCode: '请获取,并填写验证码.'
        }
        return false
      }
      let result = await this.axios.post('https://api.jarviscoder.com/super/common/ValidVerifyCode', { phone: this.phoneNumber, verifyCode: this.verifyCode }).then(({ data }) => data.Result)
      if (!result) {
        this.promptMessage = {
          verifyCode: '验证码错误.'
        }
        return false
      }
      return result
    }
  }
}
